module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Lincoln County")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "template.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title-head2",
    attrs: {
      "id": "Ack"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CKNOWLEDGMENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("Each day, a little bit of history is lost or disappears. We hope that, through our endeavors, a few photographs and memories of Lincoln County, Mississippi, have been preserved for you to enjoy.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Our sincere gratitude is expressed to the following individuals, without whose assistance this book would not have been created: Lincoln-Lawrence-Franklin Regional Library director Henry Ledet, board, and staff for the use of its vast collection of photographs and resources; all the individuals who participated in our scanning days by bringing photographs and information; Lincoln County Historical and Genealogical Society president Carroll Montgomery; Terry Pappas; Maxine Allen; Lincoln County Baptist Association and secretary Lisa Burt; countless individuals we called and visited who provided information; our title manager, Liz Gurley, and the staff at Arcadia Publishing; and, most importantly, our families, who love us and tolerate our endless pursuits of history.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Finally, to the historians and genealogists no longer with us who recorded times gone by and told their stories for future generations, we say “thank you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Images from the following sources are credited with abbreviated forms: the Lincoln-Lawrence-Franklin Regional Library (LLF), the Lincoln County Historical and Genealogical Society Museum (LCHGS), and the Mississippi Department of Archives and History (MDAH).")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-313efe6a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Acknowledgments.vue
// module id = 75
// module chunks = 0